import {
  AFFILIATION_REQUEST_EXTENSION_URL,
  AFFILIATION_REQUEST_PENDING,
} from "../constants";

/**
 * Pedido da afiliada ainda não aprovado pela prestadora: inativo + extension "pending".
 * Não conta como relação: nem torna a prestadora "prestadora", nem a afiliada "afiliada".
 */
export function isPendingAffiliationRequest(
  affiliation: fhir5.OrganizationAffiliation,
): boolean {
  return (
    affiliation.active === false &&
    Boolean(
      affiliation.extension?.some(
        (extension) =>
          extension.url === AFFILIATION_REQUEST_EXTENSION_URL &&
          extension.valueCode === AFFILIATION_REQUEST_PENDING,
      ),
    )
  );
}

/** Extension gravada no pedido da afiliada. */
export function pendingRequestExtension(): fhir5.Extension {
  return { url: AFFILIATION_REQUEST_EXTENSION_URL, valueCode: AFFILIATION_REQUEST_PENDING };
}
